// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/apps/usage_limit.proto (package qliq_protobuf.apps, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message qliq_protobuf.apps.UsageLimit
 */
export class UsageLimit extends Message<UsageLimit> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: qliq_protobuf.apps.UsageLimit.Type type = 2;
   */
  type = UsageLimit_Type.UNKNOWN_TYPE;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit = 0;

  /**
   * @generated from field: int32 total_usage = 4;
   */
  totalUsage = 0;

  /**
   * @generated from field: qliq_protobuf.apps.UsageLimit.LimitType limit_type = 5;
   */
  limitType = UsageLimit_LimitType.UNKNOWN_LIMIT_TYPE;

  /**
   * @generated from field: qliq_protobuf.apps.UsageLimit.PeriodType period_type = 6;
   */
  periodType = UsageLimit_PeriodType.UNKNOWN_PERIOD_TYPE;

  constructor(data?: PartialMessage<UsageLimit>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.apps.UsageLimit";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(UsageLimit_Type) },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "total_usage", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "limit_type", kind: "enum", T: proto3.getEnumType(UsageLimit_LimitType) },
    { no: 6, name: "period_type", kind: "enum", T: proto3.getEnumType(UsageLimit_PeriodType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UsageLimit {
    return new UsageLimit().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UsageLimit {
    return new UsageLimit().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UsageLimit {
    return new UsageLimit().fromJsonString(jsonString, options);
  }

  static equals(a: UsageLimit | PlainMessage<UsageLimit> | undefined, b: UsageLimit | PlainMessage<UsageLimit> | undefined): boolean {
    return proto3.util.equals(UsageLimit, a, b);
  }
}

/**
 * @generated from enum qliq_protobuf.apps.UsageLimit.Type
 */
export enum UsageLimit_Type {
  /**
   * @generated from enum value: UNKNOWN_TYPE = 0;
   */
  UNKNOWN_TYPE = 0,

  /**
   * @generated from enum value: CHAT_WIDGET = 1;
   */
  CHAT_WIDGET = 1,

  /**
   * @generated from enum value: AGENT = 2;
   */
  AGENT = 2,

  /**
   * @generated from enum value: AUTO_CAMPAIGN = 3;
   */
  AUTO_CAMPAIGN = 3,

  /**
   * @generated from enum value: CAMPAIGN = 4;
   */
  CAMPAIGN = 4,

  /**
   * @generated from enum value: CHAT_BOT = 5;
   */
  CHAT_BOT = 5,

  /**
   * @generated from enum value: CONVERSATION = 6;
   */
  CONVERSATION = 6,

  /**
   * @generated from enum value: ENCOUNTER = 7;
   */
  ENCOUNTER = 7,

  /**
   * @generated from enum value: FAQ = 8;
   */
  FAQ = 8,

  /**
   * @generated from enum value: FORM_SUBMISSION = 9;
   */
  FORM_SUBMISSION = 9,

  /**
   * @generated from enum value: MEMBER = 10;
   */
  MEMBER = 10,

  /**
   * @generated from enum value: MMS_MESSAGE = 11;
   */
  MMS_MESSAGE = 11,

  /**
   * @generated from enum value: NON_MEMBER = 12;
   */
  NON_MEMBER = 12,

  /**
   * @generated from enum value: ONCALL_CALL = 13;
   */
  ONCALL_CALL = 13,

  /**
   * @generated from enum value: ONCALL_GROUP = 14;
   */
  ONCALL_GROUP = 14,

  /**
   * @generated from enum value: RECIPIENT = 15;
   */
  RECIPIENT = 15,

  /**
   * @generated from enum value: RECIPIENT_GROUP = 16;
   */
  RECIPIENT_GROUP = 16,

  /**
   * @generated from enum value: SCHEDULABLE_RESOURCE = 17;
   */
  SCHEDULABLE_RESOURCE = 17,

  /**
   * @generated from enum value: SMS_TEXT_MESSAGE = 18;
   */
  SMS_TEXT_MESSAGE = 18,

  /**
   * @generated from enum value: SNAP_AND_SIGN = 19;
   */
  SNAP_AND_SIGN = 19,

  /**
   * @generated from enum value: VIDEO_CALL = 20;
   */
  VIDEO_CALL = 20,

  /**
   * @generated from enum value: VIRTUAL_VISIT = 21;
   */
  VIRTUAL_VISIT = 21,

  /**
   * @generated from enum value: VISIT_PATH_USER = 22;
   */
  VISIT_PATH_USER = 22,

  /**
   * @generated from enum value: QUICK_SIGN_DOCUMENT = 23;
   */
  QUICK_SIGN_DOCUMENT = 23,

  /**
   * @generated from enum value: QUICK_FORM = 24;
   */
  QUICK_FORM = 24,

  /**
   * @generated from enum value: QLIQ_ASSISTED_CALL = 25;
   */
  QLIQ_ASSISTED_CALL = 25,

  /**
   * @generated from enum value: QUICK_SIGN_TEMPLATE = 26;
   */
  QUICK_SIGN_TEMPLATE = 26,

  /**
   * @generated from enum value: PLUS_SIGN = 27;
   */
  PLUS_SIGN = 27,

  /**
   * @generated from enum value: PLUS_FORM = 28;
   */
  PLUS_FORM = 28,

  /**
   * @generated from enum value: SCREENSHARING_CALL = 29;
   */
  SCREENSHARING_CALL = 29,

  /**
   * @generated from enum value: AI_SUMMARIZATION = 30;
   */
  AI_SUMMARIZATION = 30,
}
// Retrieve enum metadata with: proto3.getEnumType(UsageLimit_Type)
proto3.util.setEnumType(UsageLimit_Type, "qliq_protobuf.apps.UsageLimit.Type", [
  { no: 0, name: "UNKNOWN_TYPE" },
  { no: 1, name: "CHAT_WIDGET" },
  { no: 2, name: "AGENT" },
  { no: 3, name: "AUTO_CAMPAIGN" },
  { no: 4, name: "CAMPAIGN" },
  { no: 5, name: "CHAT_BOT" },
  { no: 6, name: "CONVERSATION" },
  { no: 7, name: "ENCOUNTER" },
  { no: 8, name: "FAQ" },
  { no: 9, name: "FORM_SUBMISSION" },
  { no: 10, name: "MEMBER" },
  { no: 11, name: "MMS_MESSAGE" },
  { no: 12, name: "NON_MEMBER" },
  { no: 13, name: "ONCALL_CALL" },
  { no: 14, name: "ONCALL_GROUP" },
  { no: 15, name: "RECIPIENT" },
  { no: 16, name: "RECIPIENT_GROUP" },
  { no: 17, name: "SCHEDULABLE_RESOURCE" },
  { no: 18, name: "SMS_TEXT_MESSAGE" },
  { no: 19, name: "SNAP_AND_SIGN" },
  { no: 20, name: "VIDEO_CALL" },
  { no: 21, name: "VIRTUAL_VISIT" },
  { no: 22, name: "VISIT_PATH_USER" },
  { no: 23, name: "QUICK_SIGN_DOCUMENT" },
  { no: 24, name: "QUICK_FORM" },
  { no: 25, name: "QLIQ_ASSISTED_CALL" },
  { no: 26, name: "QUICK_SIGN_TEMPLATE" },
  { no: 27, name: "PLUS_SIGN" },
  { no: 28, name: "PLUS_FORM" },
  { no: 29, name: "SCREENSHARING_CALL" },
  { no: 30, name: "AI_SUMMARIZATION" },
]);

/**
 * @generated from enum qliq_protobuf.apps.UsageLimit.LimitType
 */
export enum UsageLimit_LimitType {
  /**
   * @generated from enum value: UNKNOWN_LIMIT_TYPE = 0;
   */
  UNKNOWN_LIMIT_TYPE = 0,

  /**
   * @generated from enum value: HARD = 1;
   */
  HARD = 1,

  /**
   * @generated from enum value: SOFT = 2;
   */
  SOFT = 2,

  /**
   * @generated from enum value: UNLIMITED = 3;
   */
  UNLIMITED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(UsageLimit_LimitType)
proto3.util.setEnumType(UsageLimit_LimitType, "qliq_protobuf.apps.UsageLimit.LimitType", [
  { no: 0, name: "UNKNOWN_LIMIT_TYPE" },
  { no: 1, name: "HARD" },
  { no: 2, name: "SOFT" },
  { no: 3, name: "UNLIMITED" },
]);

/**
 * @generated from enum qliq_protobuf.apps.UsageLimit.PeriodType
 */
export enum UsageLimit_PeriodType {
  /**
   * @generated from enum value: UNKNOWN_PERIOD_TYPE = 0;
   */
  UNKNOWN_PERIOD_TYPE = 0,

  /**
   * @generated from enum value: DAY = 1;
   */
  DAY = 1,

  /**
   * @generated from enum value: WEEK = 2;
   */
  WEEK = 2,

  /**
   * @generated from enum value: MONTH = 3;
   */
  MONTH = 3,

  /**
   * @generated from enum value: YEAR = 4;
   */
  YEAR = 4,

  /**
   * @generated from enum value: CUMULATIVE = 5;
   */
  CUMULATIVE = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(UsageLimit_PeriodType)
proto3.util.setEnumType(UsageLimit_PeriodType, "qliq_protobuf.apps.UsageLimit.PeriodType", [
  { no: 0, name: "UNKNOWN_PERIOD_TYPE" },
  { no: 1, name: "DAY" },
  { no: 2, name: "WEEK" },
  { no: 3, name: "MONTH" },
  { no: 4, name: "YEAR" },
  { no: 5, name: "CUMULATIVE" },
]);

